"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var js_synchronisation_1 = require("../js-synchronisation");
var js_createTransaction_1 = __importDefault(require("../js-createTransaction"));
var js_prepareTransaction_1 = __importDefault(require("../js-prepareTransaction"));
var js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
var js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
var js_signOperation_1 = __importDefault(require("../js-signOperation"));
var js_broadcast_1 = __importDefault(require("../js-broadcast"));
var cache_1 = require("./../cache");
var logic_1 = require("../logic");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var explorerConfigAPI = __importStar(require("../../../api/explorerConfig"));
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)({
    injectGetAddressParams: function (account) {
        var perCoin = logic_1.perCoinLogic[account.currency.id];
        if (perCoin && perCoin.injectGetAddressParams) {
            return perCoin.injectGetAddressParams(account);
        }
    }
});
var updateTransaction = function (t, patch) {
    var updatedT = __assign(__assign({}, t), patch);
    if (updatedT.recipient.toLowerCase().indexOf("bc1") === 0) {
        updatedT.recipient = updatedT.recipient.toLowerCase();
    }
    return updatedT;
};
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var explorerConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, explorerConfigAPI.preload()];
            case 1:
                explorerConfig = _a.sent();
                return [2 /*return*/, {
                        explorerConfig: explorerConfig
                    }];
        }
    });
}); };
var hydrate = function (maybeConfig) {
    if (typeof maybeConfig === "object" &&
        maybeConfig &&
        maybeConfig.explorerConfig) {
        explorerConfigAPI.hydrate(maybeConfig.explorerConfig);
    }
};
var currencyBridge = {
    scanAccounts: js_synchronisation_1.scanAccounts,
    preload: preload,
    hydrate: hydrate
};
var accountBridge = {
    estimateMaxSpendable: js_estimateMaxSpendable_1["default"],
    createTransaction: js_createTransaction_1["default"],
    prepareTransaction: js_prepareTransaction_1["default"],
    updateTransaction: updateTransaction,
    getTransactionStatus: js_getTransactionStatus_1["default"],
    receive: receive,
    sync: js_synchronisation_1.sync,
    signOperation: js_signOperation_1["default"],
    broadcast: function (_a) {
        var account = _a.account, signedOperation = _a.signedOperation;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                cache_1.calculateFees.reset();
                return [2 /*return*/, (0, js_broadcast_1["default"])({
                        account: account,
                        signedOperation: signedOperation
                    })];
            });
        });
    }
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map